import { NumericRange } from "./range";
export class ModifierMapping {
    static GetLoadModifier(load) {
        switch (load) {
            case Load.Light:
                return 1;
            case Load.Medium:
                return 0.9;
            case Load.Heavy:
                return 0.8;
            case Load.VeryHeavy:
                return 0.7;
        }
    }
    static GetPaceModifier(pace) {
        switch (pace) {
            case TravellingPace.Slow:
                return 0.5;
            case TravellingPace.Normal:
                return 1;
            case TravellingPace.Fast:
                return 1.5;
        }
    }
    static GetMethodRange(method) {
        switch (method) {
            case TravellingMethod.Walking:
                return new NumericRange(15, 25);
            case TravellingMethod.Horseback:
                return new NumericRange(25, 35);
            case TravellingMethod.HorsebackFreshHorses:
                return new NumericRange(30, 50);
            case TravellingMethod.Boat:
                return new NumericRange(24, 48);
        }
    }
    static GetTerrainModifier(terrain) {
        switch (terrain) {
            case Terrain.PavedRoad:
                return 1;
            case Terrain.TravelledPath:
                return 0.9;
            case Terrain.Wilderness:
                return 0.8;
            case Terrain.Mountainous:
                return 0.5;
        }
    }
    static GetWeatherModifier(weather) {
        switch (weather) {
            case Weather.BlueSkies:
                return 1;
            case Weather.Rain:
                return 0.7;
            case Weather.Snow:
                return 0.5;
            case Weather.Extreme:
                return 0.333;
        }
    }
}
export var TravellingPace;
(function (TravellingPace) {
    TravellingPace[TravellingPace["Slow"] = 0] = "Slow";
    TravellingPace[TravellingPace["Normal"] = 1] = "Normal";
    TravellingPace[TravellingPace["Fast"] = 2] = "Fast";
})(TravellingPace || (TravellingPace = {}));
export var Load;
(function (Load) {
    Load[Load["Light"] = 0] = "Light";
    Load[Load["Medium"] = 1] = "Medium";
    Load[Load["Heavy"] = 2] = "Heavy";
    Load[Load["VeryHeavy"] = 3] = "VeryHeavy";
})(Load || (Load = {}));
export var Terrain;
(function (Terrain) {
    Terrain[Terrain["PavedRoad"] = 0] = "PavedRoad";
    Terrain[Terrain["TravelledPath"] = 1] = "TravelledPath";
    Terrain[Terrain["Wilderness"] = 2] = "Wilderness";
    Terrain[Terrain["Mountainous"] = 3] = "Mountainous";
})(Terrain || (Terrain = {}));
export var TravellingMethod;
(function (TravellingMethod) {
    TravellingMethod[TravellingMethod["Walking"] = 0] = "Walking";
    TravellingMethod[TravellingMethod["Horseback"] = 1] = "Horseback";
    TravellingMethod[TravellingMethod["HorsebackFreshHorses"] = 2] = "HorsebackFreshHorses";
    TravellingMethod[TravellingMethod["Boat"] = 3] = "Boat";
})(TravellingMethod || (TravellingMethod = {}));
export var Weather;
(function (Weather) {
    Weather[Weather["BlueSkies"] = 0] = "BlueSkies";
    Weather[Weather["Rain"] = 1] = "Rain";
    Weather[Weather["Snow"] = 2] = "Snow";
    Weather[Weather["Extreme"] = 3] = "Extreme";
})(Weather || (Weather = {}));
//# sourceMappingURL=enums.js.map